import { SettingsSection } from '@components'

import { Space } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { DefaultColorSettings } from './elements/DefaultColorSettings'
import { DefaultFont } from './elements/DefaultFont'
import { DefaultInvoiceLogo } from './elements/DefaultInvoiceLogo'

export const AppearanceSettings = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <SettingsSection.Content title={t('settings.organization.external_invoice.appearance.title')}>
      <DefaultInvoiceLogo />
      <Space />
      <DefaultFont />
      <Space size="s24" />
      <DefaultColorSettings />
    </SettingsSection.Content>
  )
}
